// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProfileAdminTools":"iz_a bhm_vu bhm_ql bhm_va bhm_gy bhm_kg bhm_sv","ProfileAdminTools__item":"iz_b"};